export default function(text, duration = 2000) {
  const containerElement = document.createElement("div");
  containerElement.setAttribute(
    "style",
    "position: fixed;top: 50%;left: 50%;z-index: 999;transform: translate(-50%,-50%) ;padding:33px 27px;width:240px;background:rgba(0,0,0,0.7);border-radius:12px;"
  );
  const pElement = document.createElement("p");
  pElement.setAttribute(
    "style",
    "font-size:16px;font-weight:500;color:rgba(255,255,255,1);line-height:22px;text-align:center;"
  );
  pElement.innerText = text;
  containerElement.appendChild(pElement);
  document.body.appendChild(containerElement);
  setTimeout(() => {
    document.body.removeChild(containerElement);
  }, duration);
}
